import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import LinearProgress from '@mui/material/LinearProgress';


const emptyDataGridCols = [{field: '', headerName: '', flex: 1}]


export default function FullDataGrid(props) {
    const { 
        apiRef, columns, disableSelection,
        loading, onCellClick, onCellEditStop, onCellKeyDown,
        onRowClick, onRowOrderChange, rows, rowReordering,
    } = props
    return (
        <DataGridPro
            sx={{
                bgcolor: "rgba(0,0,0,0.9)",
                boxShadow: 2,
                border: 0,
                '& .MuiSvgIcon-root': {
                    color: "rgba(178, 186, 194, 0.4)"
                },
                '& .MuiDataGrid-footerContainer': {
                    borderTop: "1px solid rgba(224, 224, 224, 0.8)"
                },
                '& .MuiDataGrid-overlay': {
                    backgroundColor: "rgba(255, 255, 255, 0.01)",
                    color:'white'
                },
                '& .MuiDataGrid-row.Mui-selected': {
                    backgroundColor: "rgba(36, 108, 164, 0.35)",
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                    color: "rgb(255, 255, 255)",
                    fontWeight: "bold",
                },
                '& .MuiDataGrid-columnHeadersInner': {
                    backgroundColor: "rgba(0, 0,0 , 0.1)",
                },
                '& .MuiDataGrid-pinnedColumns': {
                    backgroundColor: "#1c2025",
                    backgroundImage: 'none',
                    
                    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 50%), 0px 2px 2px 0px rgb(0 0 0 / 40%), 0px 1px 5px 0px rgb(36 108 164 / 90%)',
                },
                '& .MuiDataGrid-pinnedColumnHeaders': {
                    backgroundColor: "rgb(40,44,52)",
                    backgroundImage: 'none',
                    boxShadow: 'none',
                    borderColor: "rgba(77, 78, 82, 0.7)",
                },              
                '& .MuiDataGrid-cell': {
                color: "rgb(255, 255, 255)",
                borderColor: "rgba(77, 78, 82, 0.7)",
                },
                '& .MuiDataGrid-virtualScroller': {
                    flex: "1 1 0px",
                    overflow: "auto"
                },
                '& .MuiLinearProgress-root':{
                    backgroundColor:'green'
                },
                
            }}
            slots={{ 
                LoadingOverlay: LinearProgress, 
            }}
            loading={loading}
            apiRef={apiRef}
            columns={columns}
            disableRowSelectionOnClick={disableSelection}
            onCellClick={onCellClick}
            onCellEditStop = {onCellEditStop}
            onCellKeyDown = {onCellKeyDown}
            onRowClick={onRowClick}
            onRowOrderChange = {onRowOrderChange}
            rowReordering = {rowReordering}
            rows={rows}
        />
    )
}

FullDataGrid.defaultProps = {
    apiRef: null,
    columns: emptyDataGridCols,
    disableSelection: false,
    onCellClick: () => {},
    onCellEditStop: () => {},
    onCellKeyDown: () => {},
    onRowClick: () => {},
    onRowOrderChange: () => {},
    rows: [],
    rowReordering: false,
}